import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Pencil, Trash2, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";
import { PROGRAMS } from "@/data";

export default function PagesList() {
  const [dbPages, setDbPages] = useState([]);
  const load = () => api.get("/pages").then((r) => setDbPages(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const map = {};
  Object.values(PROGRAMS).forEach((p) => { map[p.slug] = { slug: p.slug, title: p.title, source: "default" }; });
  dbPages.forEach((p) => { map[p.slug] = { slug: p.slug, title: p.title || p.slug, source: "edited" }; });
  const rows = Object.values(map).sort((a, b) => a.title.localeCompare(b.title));

  const remove = async (slug) => {
    if (!window.confirm(`Delete page "${slug}"? Default pages will revert to built-in content.`)) return;
    await api.delete(`/pages/${slug}`); load();
  };

  return (
    <div data-testid="admin-pages">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h1 className="font-heading text-2xl font-semibold">Pages</h1>
          <p className="text-sm text-slate-500">Inner pages built on the Meditation &amp; Mindfulness template.</p>
        </div>
        <Link to="/admin/pages/new" data-testid="new-page-btn" className="inline-flex items-center gap-2 rounded-full bg-brand-magenta px-5 py-2.5 text-sm font-semibold text-white hover:opacity-90">
          <Plus className="h-4 w-4" /> New Page
        </Link>
      </div>
      <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-400">
            <tr><th className="px-5 py-3">Title</th><th className="px-5 py-3">Slug</th><th className="px-5 py-3">Status</th><th className="px-5 py-3 text-right">Actions</th></tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.slug} data-testid={`page-row-${r.slug}`} className="border-t border-slate-100">
                <td className="px-5 py-3 font-medium">{r.title}</td>
                <td className="px-5 py-3 text-slate-500">/{r.slug}</td>
                <td className="px-5 py-3">
                  <span className={`rounded-full px-2.5 py-1 text-xs font-medium ${r.source === "edited" ? "bg-green-100 text-green-700" : "bg-slate-100 text-slate-500"}`}>
                    {r.source === "edited" ? "Edited" : "Default"}
                  </span>
                </td>
                <td className="px-5 py-3">
                  <div className="flex items-center justify-end gap-2">
                    <a href={`/programs/${r.slug}`} target="_blank" rel="noreferrer" className="rounded p-1.5 text-slate-400 hover:bg-slate-100 hover:text-brand-ink" title="View"><ExternalLink className="h-4 w-4" /></a>
                    <Link to={`/admin/pages/${r.slug}`} data-testid={`edit-page-${r.slug}`} className="rounded p-1.5 text-slate-400 hover:bg-slate-100 hover:text-brand-magenta" title="Edit"><Pencil className="h-4 w-4" /></Link>
                    {r.source === "edited" && <button onClick={() => remove(r.slug)} className="rounded p-1.5 text-slate-400 hover:bg-red-50 hover:text-red-500" title="Delete"><Trash2 className="h-4 w-4" /></button>}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
